
export function toBase64(str) {
    return btoa(unescape(encodeURIComponent(str)));
}

export function isOnlyNumber(str) {
    return (/^[0-9]+$/).test(str);
}

export function compareVersions(version, base) {
    const v1 = version.split('.').map(Number);
    const v2 = base.split('.').map(Number);

    for (let i = 0; i < Math.max(v1.length, v2.length); i++) {
        const num1 = v1[i] || 0;
        const num2 = v2[i] || 0;

        if (num1 > num2) return 1; // version is greater
        if (num1 < num2) return -1; // version is smaller
    }

    return 0; // versions are equal
}


export function deleteCookie(name) {
  if (document.cookie.split(';').some(cookie => cookie.trim().startsWith(name + '='))) {
    // Expire the cookie by setting an old date
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    console.log(`Cookie '${name}' deleted.`);
  } else {
    console.log(`Cookie '${name}' not found.`);
  }
}

export function groupProductsByFamily(data) {
  const result = [];
  const familyMap = new Map();

  data.forEach(item => {
    if (!item.familyName) {
      // No family name, push directly
      result.push(item);
    } else {
      // If family name exists, group by it
      if (!familyMap.has(item.familyName)) {
        familyMap.set(item.familyName, []);
      }
      familyMap.get(item.familyName).push(item);
    }
  });

  // Convert grouped families into objects and push into result
  for (const [familyName, products] of familyMap) {
    result.push({ familyName, products });
  }

  return result;
}


export function removeClass(element, className){
  if(element.classList.contains(className)){
    element.classList.remove(className)
  }
}
export function addClass(element, className){
  if(!element.classList.contains(className)){
    element.classList.add(className)
  }
}
